// メッセージMap
export const MessageMap = {
    "user_name": "ユーザ名",
    "user_kind": "登録者種別",
    "status_of_residence": "在留資格",
    "organization_id": "組織名",
    "organization_name": "組織名",
    "user_mail_address": "メールアドレス",
    "version_no": "バージョン番号"
};